(function () {
  'use strict';

  function initRec(root) {
    if (!root || root.dataset.pfRecInit) return;
    root.dataset.pfRecInit = '1';

    var track = root.querySelector('[data-pf-rec-track]');
    if (!track) return;

    function updateNav() {
      root.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 2);
    }

    function cardsFrom(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var t = doc.querySelector('[data-pf-rec-track]');
      return t && t.querySelector('.pf-rec-item') ? t.innerHTML : null;
    }

    function load(url) {
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(cardsFrom)
        .catch(function () { return null; });
    }

    function reveal() {
      if (track.querySelector('.pf-rec-item')) root.hidden = false;
      updateNav();
    }

    function fill(html) {
      if (html) track.innerHTML = html;
      reveal();
    }

    var source = root.getAttribute('data-source');
    var url = root.getAttribute('data-url');
    var fallbackUrl = root.getAttribute('data-fallback-url');
    var hasCards = !!track.querySelector('.pf-rec-item');

    if (source === 'auto' && url) {
      // Shopify-Empfehlungen nachladen; bleiben sie leer, greift der related-Fallback.
      load(url)
        .then(function (html) {
          if (html) return html;
          return fallbackUrl ? load(fallbackUrl) : null;
        })
        .then(fill);
    } else if (!hasCards && fallbackUrl) {
      // Serverseitige Quelle (Metafeld, Kollektion, manuell) hat nichts geliefert.
      load(fallbackUrl).then(fill);
    } else {
      reveal();
    }

    var prev = root.querySelector('[data-pf-rec-prev]');
    var next = root.querySelector('[data-pf-rec-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }); });
    window.addEventListener('resize', updateNav);

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pf-rec-add]');
      if (!btn || btn.disabled) return;
      var label = btn.getAttribute('data-label');
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw res.data;
          btn.textContent = btn.getAttribute('data-added-label') || label;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.jQuery) { try { window.jQuery(document).trigger('cart:build'); } catch (e2) {} }
        })
        .catch(function () { btn.textContent = 'Fehler'; })
        .finally(function () {
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pf-rec]').forEach(initRec);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();